import React, { useEffect } from "react";
import * as Icons from "@wix/wix-ui-icons-common";
import {
  Box,
  Button,
  Card,
  WixDesignSystemProvider,
  MarketingPageLayout,
  MarketingPageLayoutContent,
  Page,
  Loader,
  Notification,
} from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import { ReactTagManager } from "react-gtm-ts";
import { useTranslation } from "react-i18next";
import { initAnalytics, track } from "./analytics";

const tagManagerArgs = {
  code: "GTM-WZQPMC7",
};

function App() {
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get("token");
  const instance = new URLSearchParams(window.location.search).get("instance");
  const [isUpgraded, setIsUpgraded] = React.useState(false);
  const [instanceData, setInstanceData] = React.useState({
    instance: {
      isFree: true,
      availablePlans: [],
      instanceId: "",
    },
  } as any);

  const isFree = instanceData?.instance?.isFree !== false;

  const [isUpgradeBannerOpen, setIsUpgradeBannerOpen] =
    React.useState<boolean>(isFree);

  useEffect(() => {
    ReactTagManager.init(tagManagerArgs);
    initAnalytics();
    loadInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const BASE_URL = "https://wix.certifiedcode.io/w-tdl/_functions";
  const WIX_APP_ID = "a82c2774-7d08-4ebc-8d38-d9d6752c5f92";

  function loadInstance() {
    fetch(BASE_URL + "/@certifiedcode/base-backend/instance", {
      method: "GET",
      headers: { Authorization: instance || "" },
    })
      .then((response) => response.json())
      .then((data) => {
        setInstanceData(data);
        const upgraded = data?.instance?.isFree === false;
        setIsUpgraded(upgraded);
        setIsUpgradeBannerOpen(!upgraded);
      })
      .catch(() => {});
  }

  const upgradeUrl = `https://memberships.certifiedcode.us/${window.location.search}`;

  if (token) {
    return (
      <WixDesignSystemProvider features={{ newColorsBranding: true }}>
        <Page height="100vh">
          <Page.Content>
            <Box height={"90vh"} direction="vertical" verticalAlign="middle">
              <Loader text={t("loading")} />
            </Box>
          </Page.Content>
        </Page>
      </WixDesignSystemProvider>
    );
  }

  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <Notification theme="premium" show={isUpgradeBannerOpen} type={"sticky"}>
        <Notification.TextLabel>
          {t("upgrade-text")}
        </Notification.TextLabel>
        <Notification.ActionButton
          onClick={() => {
            track("upgrade_clicked"); window.open(upgradeUrl, "_blank");
          }}
        >{t("upgrade-button")}</Notification.ActionButton>
        <Notification.CloseButton
          onClick={() => setIsUpgradeBannerOpen(false)}
        />
      </Notification>
      <Card>
        <MarketingPageLayout
          removeImageHorizontalPadding
          removeImageVerticalPadding
          content={
            <Box height="840px" verticalAlign="middle">
              <MarketingPageLayoutContent
                title={t("tdl-title")}
                content={t("tdl-content")}
                actions={
                  <Box gap="SP2">
                    <Button
                      suffixIcon={<Icons.Edit />}
                      as="a"
                      href={`https://www.wix.com/editor/${instanceData?.site?.siteId}`}
                      target="_blank"
                    >{t("tdl-edit-button")}</Button>
                    <Button
                      suffixIcon={<Icons.PremiumFilled />}
                      skin={isUpgraded ? "premium-light" : "premium"}
                      as="a"
                      href={upgradeUrl}
                      target="_blank"
                    >
                      {isUpgraded ? t("tdl-manage-button") : t("tdl-upgrade-button")}
                    </Button>
                  </Box>
                }
              />
            </Box>
          }
        />
      </Card>
    </WixDesignSystemProvider>
  );
}

export default App;
